import posed from 'react-pose';



const PageAnimation = posed.div({
    enter: { 
        x: '0%',
        opacity:1,
        transition: { duration: 900 } 
    },
    exit: {
        opacity:function({frompage,topage,animP}) {
            if(
                topage ==="/" && animP ==="/details" ||
                topage ==="/about" && animP ==="/details" ||
                topage ==="/work" && animP ==="/details" ||
                topage ==="/contact" && animP ==="/details"
            ){
                return 1
            } else if(
                frompage.startsWith("/work/") && animP ==="/details" 
            ){
                return 0
            } else {
                return 1
            }
            
        },
        x: function({frompage, topage,mainfrompage, maintopage, animP}) {
            //console.log("startsWith" + topage.startsWith("/work/"))
            if(topage === animP){
                
            }
            if(
                topage ==="/contact" && animP ==="/" ||
                frompage ==="/contact" && animP ==="/" ||
                topage ==="/work" && animP ==="/" ||
                frompage ==="/work" && animP ==="/" ||
                topage ==="/" && animP ==="/about" ||
                frompage ==="/" && animP ==="/about" ||
                topage ==="/work" && animP ==="/about" ||
                frompage ==="/work" && animP ==="/about" ||
                topage ==="/contact" && animP ==="/work" ||
                frompage ==="/contact" && animP ==="/work" ||
                topage ==="/contact" && animP ==="/about" ||
                frompage ==="/contact" && animP ==="/about" ||
                frompage.startsWith("/work/") && animP ==="/work" ||
                topage.startsWith("/work/") && animP ==="/work" ||
                topage.startsWith("/work/") && animP ==="/contact" ||
                frompage.startsWith("/work/") && animP ==="/contact" ||
                topage.startsWith("/work/") && animP ==="/about" ||
                frompage.startsWith("/work/") && animP ==="/about" 
                
            ){
                //console.log("topage /work/ animP /work  -100%");
                return '-100%'
            }
            if(
                frompage ==="/" && animP ==="/contact" ||
                topage ==="/" && animP ==="/contact" ||
                frompage ==="/" && animP ==="/work" ||
                topage ==="/" && animP ==="/work" ||
                frompage ==="/about" && animP ==="/" ||
                topage ==="/about" && animP ==="/" ||
                frompage ==="/about" && animP ==="/work" ||
                topage ==="/about" && animP ==="/work" ||
                frompage ==="/work" && animP ==="/contact" ||
                topage ==="/work" && animP ==="/contact" ||
                topage ==="/about" && animP ==="/contact" ||
                frompage ==="/about" && animP ==="/contact" ||
                topage ==="/work" && animP ==="/details" ||
                frompage ==="/work" && animP ==="/details" ||
                frompage ==="/contact" && animP ==="/details" ||
                topage ==="/contact" && animP ==="/details" ||
                frompage ==="/about" && animP ==="/details" ||
                topage ==="/about" && animP ==="/details" 

            ){
                //console.log("frompage /work animP /details  100%");
                return '100%'
            }
        },
        transition: { duration: 900 } 
    }
});

  
  
  export default PageAnimation;


// WEBPACK FOOTER //
// ./src/components/PageTransitions.js